<h1 mat-dialog-title>Try LINQ for your organisation</h1>
<mat-dialog-content>
    @if (data.messages) {
        @for (m of data.messages; track $index) {
            <p class="message" [innerHTML]="m"></p>
        }
    }

    <form [formGroup]="registrationForm" (ngSubmit)="register()" class="form-content" autocomplete="on">
        <mat-form-field appearance="fill">
            <mat-label>Organisation name</mat-label>
            <mat-icon matPrefix>domain</mat-icon>
            <input type="text" matInput formControlName="organisation" autocomplete="organization" id="register-organisation" [maxlength]="ORGANISATION_NAME_MAX" required cdkFocusInitial>
            @if (registrationForm.controls['organisation'].invalid) {
                <mat-error>Organisation name must be between {{ORGANISATION_NAME_MIN}} and {{ORGANISATION_NAME_MAX}} characters</mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Your name</mat-label>
            <mat-icon matPrefix>person</mat-icon>
            <input type="text" matInput formControlName="usersname" autocomplete="name" id="register-name" [maxlength]="USER_NAME_MAX" required>
            @if (registrationForm.controls['usersname'].invalid) {
                <mat-error>Your name must be between {{USER_NAME_MIN}} and {{USER_NAME_MAX}} characters</mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <mat-icon matPrefix>email</mat-icon>
            <input type="email" matInput formControlName="email" autocomplete="email" id="register-email" [maxlength]="EMAIL_MAX" required>
            <mat-hint>You'll use this to sign in</mat-hint>
            @if (registrationForm.controls['email'].invalid) {
                <mat-error>Enter a valid email address</mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" autocomplete="new-password" id="register-password" [maxlength]="PASSWORD_MAX" required>
            <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
                <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-hint>{{PASSWORD_MIN}} to {{PASSWORD_MAX}} characters</mat-hint>
            @if (registrationForm.controls['password'].invalid) {
                <mat-error>Password must be between {{PASSWORD_MIN}} and {{PASSWORD_MAX}} characters</mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Confirm password</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="passwordConfirmation" autocomplete="new-password" id="register-password-confirmation" [maxlength]="PASSWORD_MAX" required>
            @if (registrationForm.controls['passwordConfirmation'].hasError('required')) {
                <mat-error>Enter the password again</mat-error>
            }
        </mat-form-field>
        @if (passwordsDiffer()) {
            <p class="error" role="alert">The passwords don't match</p>
        }

        @if (data.model) {
            <mat-slide-toggle formControlName="createModel">Copy the model <b>{{data.model.name}}</b> into my new organisation</mat-slide-toggle>
        }

        @if (errorMessage) {
            <p class="error" role="alert">{{errorMessage}}</p>
        }

        <button type="submit" mat-flat-button color="accent" class="register-button" [disabled]="registering">
            {{registering ? 'Registering…' : 'Register'}}
        </button>
    </form>

    <div class="social">
        @if (canUseSocialSignIn()) {
            <p>Or register with your Microsoft or Google account:</p>
            <div class="social-buttons">
                <button type="button" class="ms-button" (click)="loginMicrosoft()" aria-label="Sign in with Microsoft">
                    <img data-testid="msregisterButton" src="assets/images/ms-symbollockup_signin_light.png" alt="Sign in with Microsoft">
                </button>
                <asl-google-signin-button type='standard' size='medium'></asl-google-signin-button>
            </div>
        }@else {
            <p class="note">Enter your organisation name to register with a Microsoft or Google account instead.</p>
        }
    </div>

    <p class="terms">
        By registering you agree to the LINQ
        <a href="https://www.thinklikelinq.com/terms-of-use/" target="_blank" rel="noopener">terms of use</a> and
        <a href="https://www.thinklikelinq.com/privacy-policy/" target="_blank" rel="noopener">privacy policy</a>.
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>
